import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router'; 
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routing } from './app.routing';
//import { MediumEditorComponent } from 'ng2-meditor';
// import { IndoorMapsToolModule } from '@insuide/indoor-map-library';
//import { IndoorMapsToolModule } from '@insuide/indoor-map-library';

//guards
import { LoggedinGuard } from './guards/loggedin/loggedin.guard';


//services
import { WebService } from './services/web/web.service';
import { EncryptService } from './services/encrypt/encrypt.service';
import { DialogService } from './services/dialog/dialog.service';
import { PassdataService } from './services/passdata/passdata.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { AlertdialogComponent } from './alertdialog/alertdialog.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { AddmenuComponent } from './addmenu/addmenu.component';
import { TemplateComponent } from './template/template.component';
import { AssignmenuComponent } from './assignmenu/assignmenu.component';
import { TreeModule } from 'angular-tree-component';

import { WINDOW_PROVIDERS } from './services/window.providers';//added by vijay
import {SocketService} from './services/socket/socket.service';//added by vijay 


import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';//added by vijay
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    RouterModule,
    
    NgbModule.forRoot(),
    ModalModule.forRoot(),
    HttpModule,
    routing,
    TreeModule.forRoot(),
    AngularMultiSelectModule
  ],
  
  declarations: [
    AppComponent,
    
   
    AlertdialogComponent,
   
    ForgotpasswordComponent,
   
    AddmenuComponent,
    
    AssignmenuComponent,
    LoginComponent,
    AdminComponent,

    TemplateComponent,
  
  
  ],
  
  providers: [WebService,DialogService,EncryptService,LoggedinGuard,WINDOW_PROVIDERS,SocketService,PassdataService],
  entryComponents: [AlertdialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts